export default import.meta.ROLLUP_FILE_URL_DUq8YoikZLXEejpNZ1KQvg